import React from 'react';

import Stack from '@mui/material/Stack';
import SubscribeScreen from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/SubscribeScreen';
import RequestAccessScreen from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/RequestAccessScreen';
import Workspace from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/Workspace';

import useUserScreenFlow from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/hooks/useUserScreenFlow';

const PaymentsWorkspace: React.FC = () => {
  const { showSubscribeScreen, showRequestAccessScreen, showWorkspace } = useUserScreenFlow();

  return (
    <>
      {showWorkspace ? (
        <Workspace />
      ) : (
        <Stack justifyContent="center" alignItems="center" height="100%">
          {showSubscribeScreen && <SubscribeScreen />}
          {showRequestAccessScreen && <RequestAccessScreen />}
        </Stack>
      )}
    </>
  );
};

export default PaymentsWorkspace;
